import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import {} from 'react-select';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { memoGeneric } from '@/js/libs/memo';
import { Icons } from '../..';
import { SelectionList, SortOrder, ITEM_MIN_HEIGHT_WITH_BORDER, } from '../../Components/SelectionList';
import { MultiSelect } from '../Select';
import { SelectListWrapper } from './styles';
import {} from './types';
const ITEM_HEIGHT = ITEM_MIN_HEIGHT_WITH_BORDER;
export const SelectList = memoGeneric(function SelectList({ dataTestId, options, value = [], onChange, initialSelectedSortOrder = SortOrder.ASC, translations, visibleRowsCount = 4, placeholder, isLoading, isDisabled, getOptionKey, formatOptionLabel, getOptionText, }) {
    const [selectedSortOrder, setSelectedSortOrder] = useState(initialSelectedSortOrder);
    const getSortLabel = useCallbackRef((option) => {
        if (getOptionText) {
            return getOptionText(option);
        }
        return formatOptionLabel?.(option) ?? option.label;
    });
    const selectedOptions = useMemo(() => value
        .map((option) => ({ ...option, sortLabel: getSortLabel(option) }))
        .sort((a, b) => selectedSortOrder === SortOrder.ASC ? a.sortLabel.localeCompare(b.sortLabel) : b.sortLabel.localeCompare(a.sortLabel)), [value, selectedSortOrder, getSortLabel]);
    const handleClear = useCallbackRef(() => {
        onChange?.([], { action: 'clear', removedValues: value });
    });
    const handleRemoveOption = useCallbackRef((option) => {
        onChange?.(value.filter((value) => value.value !== option.value), {
            action: 'deselect-option',
            removedValues: [option],
            option,
        });
    });
    const toggleSortOrder = useCallbackRef(() => {
        setSelectedSortOrder((prev) => (prev === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC));
    });
    const listTranslations = useMemo(() => ({
        header: translations.selected,
        footer: `${selectedOptions.length} ${translations.totalSeparator} ${options?.length ?? 0}`,
        bulkActionTooltip: translations.clearAll,
        noEntries: translations.noEntries,
    }), [options?.length, selectedOptions.length, translations]);
    return (_jsxs(SelectListWrapper, { "data-testid": dataTestId, children: [_jsx(MultiSelect, { controlShouldRenderValue: false, isClearable: false, isDisabled: isDisabled || isLoading, options: options, value: value, onChange: onChange, formatOptionLabel: formatOptionLabel, placeholder: placeholder }), _jsx(SelectionList, { dataTestId: `${dataTestId}-selection-list`, isLoading: isLoading, disabled: isDisabled || !selectedOptions.length, options: selectedOptions, onRowAction: handleRemoveOption, onBulkAction: handleClear, sortOrder: selectedSortOrder, onChangeSortOrder: toggleSortOrder, containerHeight: Math.max(visibleRowsCount, 1) * ITEM_HEIGHT + ITEM_HEIGHT / 2, getOptionKey: getOptionKey, formatOptionLabel: formatOptionLabel, translations: listTranslations, bulkActionIcon: _jsx(Icons.Clear, {}), rowActionIcon: _jsx(Icons.Remove, {}) })] }));
});
